exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-bbed3fac],.fade-leave-active[data-v-bbed3fac]{transition:opacity .5s}.fade-enter[data-v-bbed3fac],.fade-leave-to[data-v-bbed3fac]{opacity:0}", ""]);

// exports
